import React from 'react';
import StripeCheckout from 'react-stripe-checkout';

const StripeCheckoutButton = ({ price }) => {
  const priceForStripe = price * 100;
  const publishableKey = 'pk_test_51HL2T5D0T2f0qgYar7QpqPlv1sIZPRKRgpeLq7zC2HfXCs6w2guss0yF4k6jGf21qTG6dtoPPT6OOoIKtIW6S83p00sPCtbVtT'


  const onToken = price => {
    alert(`Successfully paid $${price}`);
  }

  return (
    <StripeCheckout
    label='Pay Now'
    name='CROWN Clothing Ltd.'
    billingAddress
    shippingAddress
    image='http://svgshare.com/i/CUz.svg'
    description={`Your totle is $${price}`}
    amount={priceForStripe}
    panelLabel='Pay Now'
    token={() => onToken(price)}
    stripeKey={publishableKey}
    />
  )
};


export default StripeCheckoutButton;